import { useEffect, useRef, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { api, ApiError } from '../lib/api.js'
import { useAuth } from '../context/AuthContext.jsx'

export default function VerifyEmail() {
  const [params] = useSearchParams()
  const token = params.get('token') || ''
  const { refresh } = useAuth()
  const [state, setState] = useState(token ? 'working' : 'missing')
  const [message, setMessage] = useState('')
  const ran = useRef(false)

  useEffect(() => {
    document.title = 'Email verification — Sonologue'
  }, [])

  useEffect(() => {
    // React 18+ mounts effects twice in development; the token is single-use,
    // so the second call would report a valid link as expired.
    if (!token || ran.current) return
    ran.current = true
    api
      .confirmEmailVerification({ token })
      .then(() => {
        setState('done')
        return refresh()
      })
      .catch((error) => {
        setState('failed')
        setMessage(error instanceof ApiError ? error.message : 'Something went wrong. Try again.')
      })
  }, [token, refresh])

  return (
    <div className="auth-shell">
      <div className="card card-pad auth-card fade-up">
        <h1 className="auth-heading">Email verification</h1>
        {state === 'working' ? <p className="auth-sub">Checking your link…</p> : null}
        {state === 'done' ? <p className="auth-sub">Your email address is confirmed.</p> : null}
        {state === 'missing' ? <p className="auth-sub">This link is missing its token.</p> : null}
        {state === 'failed' ? <p className="auth-sub">{message}</p> : null}
        {/* Only a confirmed address has a feed to go to. `/` is inside
            `AppLayout`, so offering it to somebody whose link had no token —
            or whose token failed — bounced them to `/login` and told them
            their session was the problem when their link was. Every state but
            `done` therefore offers the sign-in form directly, `working`
            included: the page does not yet know it has anything better. */}
        <p className="auth-alt">
          {state === 'done' ? (
            <Link to="/">Go to your feed</Link>
          ) : (
            <Link to="/login">Sign in</Link>
          )}
        </p>
      </div>
    </div>
  )
}
